import { useGetOne } from "react-admin";
import { Box } from "@mui/material";
import { useParams, useSearchParams } from "react-router";

import {
  RazaUnifiedPrintContent,
  type RazaUnifiedPrintRecord,
} from "@/components/raza/RazaUnifiedPrintContent";

const RazaRequestRazaPrint = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const includeCommitments =
    searchParams.get("commitments") === "1" || searchParams.get("commitments") === "true";
  const { data, isLoading } = useGetOne("razaRequests", { id: id ?? "" });

  if (isLoading || !data) return <Box p={3}>...Loading</Box>;

  return (
    <RazaUnifiedPrintContent
      record={data as RazaUnifiedPrintRecord}
      includeCommitments={includeCommitments}
    />
  );
};

export default RazaRequestRazaPrint;
